import { Injectable } from '@angular/core';
import { Event, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PreviousUrlService {
  previousUrl: string | null = null;
  currentUrl: string | null = null;
  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter((evt: Event): evt is RoutesRecognized => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
        this.currentUrl = events[1].urlAfterRedirects;
      });
  }
}
